<ntap-view-window target="globalDialog"></ntap-view-window>
<ng-container *ngIf="currentViewState">
  <ng-container
    ntapFilterViewProvider
    [viewName]="currentViewName"
    [viewState]="currentViewStateFilter"
  >
    <ng-container
      ntapListViewProvider
      [viewName]="currentViewName"
      [viewState]="currentViewState"
      #listViewProvider="ntapListViewProvider"
    >
      <ng-container ntapWindowRegistry>
        <ntap-dynamic compId="ntapFilterView" #filterContainer></ntap-dynamic>
        <ntap-dynamic
          [compId]="INIT_COMP_ID"
          [class]="currentViewClass"
        ></ntap-dynamic>
        <ntap-view-window target="detail" [contentTemplate]="viewWindowContent">
          <ng-template #viewWindowContent let-defaultTemplate>
            <ntap-prime-popupview appendTo="body" [modal]="true">
              <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
            </ntap-prime-popupview>
          </ng-template>
        </ntap-view-window>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>